import Role from "@mapmycustomers/shared/enum/Role";
import type User from "@mapmycustomers/shared/types/User";

import { isManager, isMember, isReadOnly } from "@app/store/iam/util";

/**
 * Whether `currentUser` may see `user`'s location (owners: all; managers: their teams;
 * members/read-only: self — role cases covered in the unit tests). Single source
 * of truth: keep the three enforcement points in sync — the markers
 * (`UserLocation`), the legend (`UserLocationList`), and the `onSelectUserById` saga.
 */
const isUserLocationVisibleToMe = (currentUser: User, user: User): boolean => {
  if ((isMember(currentUser) || isReadOnly(currentUser)) && user.id !== currentUser.id) {
    return false;
  }
  if (isManager(currentUser)) {
    const onMyTeam = user.teams.some((team) => currentUser.teams.some(({ id }) => id === team.id));
    const allowedRole = user.role.key === Role.MANAGER || user.role.key === Role.MEMBER;
    if (!onMyTeam || !allowedRole) {
      return false;
    }
  }
  return true;
};

export default isUserLocationVisibleToMe;
